import React from 'react';
import { PropTypes } from 'prop-types';
import './popup.scss';

export const Popup = ({ togglePopup, headText, secondaryMessage, buttonMessage }) => (
  <div className='popup-container active-modal'>
    <div className='modal container-vh'>
      <div className='overlay' onClick={togglePopup} />
      <div className='modal-content'>
        <h2>{headText}</h2>
        <p>{secondaryMessage}</p>
        <button className='close-modal' type='button' onClick={togglePopup}>
          X
        </button>
        <button className='primary-button' type='button' onClick={togglePopup}>
          {buttonMessage}
        </button>
      </div>
    </div>
  </div>
);

Popup.propTypes = {
  headText: PropTypes.string,
  secondaryMessage: PropTypes.string,
  buttonMessage: PropTypes.string,
  togglePopup: PropTypes.func,
};
